import { t } from 'i18next';

import type { AddOnAssignment } from '~hooks/useAddOns/models';
import reportRequestError from '~services/reportRequestError';

/** Fetches and applies one owner type's auto add-ons; a failure is reported once, never thrown. */
export async function loadAutoAddOnAssignments(
  fetchAddOnAssignments: () => Promise<AddOnAssignment[]>,
  apply: (addOnAssignments: AddOnAssignment[]) => void,
): Promise<void> {
  try {
    apply(await fetchAddOnAssignments());
  } catch (error) {
    reportRequestError(
      error,
      t('error_messages.auto_add_on_assignments.failed_to_fetch'),
    );
  }
}
